module.exports = __webpack_public_path__ + "img/nihon-kohden_TEC8300.9295c49b.png";